<template>
  <category-page
    :resource-type="category.name"
    :resource-params="resourceParams"
    :available-filters="availableFilters"
    :parent="parent"
  />
</template>

<script>
/* List resources by resource type
 *
 * @parent:
 * @requests: /public/v1/category
 * @events:
 * @props:
 * @components: CategoryPage
 * @methods:
 */

import CategoryPage from '~/components/category/CategoryPage.vue';
import { longCategoryTitle } from '~/utils/category';

const root = 'resource-type';

export default {
  name: 'ResourceType',
  components: {
    CategoryPage,
  },
  async asyncData({ app, store, route, params, error }) {
    const data = {};
    const loggedInUser = store.getters.loggedInUser;

    // For the resource list query
    data.resourceParams = {
      category: params.slug,
      perPage: 32,
      root: root + '-' + app.i18n.locale,
    };

    // Auto-select user's year level(s) when making a query
    if (loggedInUser && loggedInUser.year_levels) {
      data.resourceParams.year_levels = loggedInUser.year_levels;
    }

    try {
      // Load the category title, description and list of sub-categories
      const category = await store.dispatch('loadCategory', {
        category: params.slug,
        root: root + '-' + app.i18n.locale,
        link: route.path,
      });

      // For meta fields
      data.title = longCategoryTitle(category.name, app.i18n.locale, category.name);
      data.category = category;
    } catch (err) {
      // No page matching this route
      error({ statusCode: 404, message: err.message, path: route.path });
    }
    return data;
  },
  data() {
    return {
      title: null,
      category: null,
      metaLinks: null,
      parent: { link: '/' + this.$i18n.locale + '/resource-types/', name: 'Resource Types' },
      resourceParams: null,
      availableFilters: [
        'types',
        'learning_areas',
        'year_levels',
        'availability',
        'file_formats',
        'publishers',
      ],
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: this.$metaPropertiesCategory(this.category, { title: this.title }),
      link: this.$hrefLangsResource(
        this.category.linked,
        this.category.link,
        this.$i18n.locale,
        this.$route
      ),
    };
  },
};
</script>
